/**
 * 商品ページ：カート追加後にポップアップを表示し、ページ遷移を防ぐ
 */
(function () {
  'use strict';

  var popup = document.getElementById('CartAddPopup');
  if (!popup) return;

  var overlay = popup.querySelector('.cart-add-popup__overlay');
  var closeBtn = popup.querySelector('[data-cart-add-popup-close]');
  var continueBtn = popup.querySelector('[data-cart-add-popup-continue]');
  var productTitleEl = popup.querySelector('[data-cart-add-popup-product]');
  var isSubmitting = false;

  function refreshCartUI() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  function openPopup(productTitle) {
    if (productTitleEl) {
      productTitleEl.textContent = productTitle
        ? '「' + productTitle + '」をカートに追加しました。'
        : '商品をカートに追加しました。';
    }
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-add-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-add-popup-open');
  }

  function getProductTitle(form) {
    var section = form.closest('.product-section, .thb-product-detail, [data-handle]');
    if (!section) return '';

    var titleEl = section.querySelector('.product-title, .product__title, h1');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function setButtonLoading(form, loading) {
    var buttons = form.querySelectorAll('[type="submit"], [name="add"]');
    buttons.forEach(function (btn) {
      btn.disabled = loading;
      if (loading) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function handleAddToCart(form) {
    if (isSubmitting) return;
    isSubmitting = true;
    setButtonLoading(form, true);

    var formData = new FormData(form);

    var cartAddUrl =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw data;
          }
          return data;
        });
      })
      .then(function (item) {
        refreshCartUI();
        openPopup(item.product_title || getProductTitle(form));
      })
      .catch(function (error) {
        var message =
          (error && error.description) ||
          (error && error.message) ||
          'カートに追加できませんでした。';
        alert(message);
      })
      .finally(function () {
        isSubmitting = false;
        setButtonLoading(form, false);
      });
  }

  function isProductAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return (
      form.getAttribute('data-type') === 'add-to-cart-form' ||
      action.indexOf('/cart/add') !== -1
    );
  }

  function onFormSubmit(event) {
    var form = event.target;
    if (!isProductAddForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    handleAddToCart(form);
  }

  document.addEventListener('submit', onFormSubmit, true);

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  if (continueBtn) {
    continueBtn.addEventListener('click', closePopup);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });
})();
